import { Directive, ElementRef, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from "@angular/core";
import { CoreCOMService } from "../../services/com.service";
import { CoreLogService } from "../../services/log.service";

import { Subscription } from "rxjs";
import { CoreVideoService } from "../../services/video.service";

/** Video Direktive für <video class="ya_video" [src]="model.image_name" /> **/
@Directive({
  selector: "video.ya_video"
})
export class CoreVideoDirective implements OnInit, OnChanges, OnDestroy {
  @Input() private src: string;

  private _coreVideoService: CoreVideoService = null;
  private _subscription: Subscription = null;

  constructor(private _el: ElementRef,
    _coreCOMService: CoreCOMService,
    private _coreLogService: CoreLogService) {
    // todo CoreVideoService injectable machen, um es nur einmal zu laden
    this._coreVideoService = new CoreVideoService(_coreCOMService);
  }

  ngOnInit(): void {
  }

  private async setVideo(path: string) {
    const me = this;
    if (path && path.length > 0) {
      me._subscription = me._coreVideoService.getURLByPath(path).subscribe((url) => {
        me._el.nativeElement.setAttribute("src", url);
      }, (error) => {
        me._el.nativeElement.setAttribute("src", CoreVideoService.errorImageURL);
        me._coreLogService.error("CoreVideoDirective.ngOnInit", "getURLByPath(" + path + ")", error);
      }, () => {
        if (me._subscription !== null) {
          me._subscription.unsubscribe();
          me._subscription = null;
        }
      });
    } else {
      me._el.nativeElement.setAttribute("src", CoreVideoService.errorImageURL);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const me = this;
    const src = changes["src"];
    if (src && (src.firstChange || src.currentValue !== src.previousValue)) {
      if (src.firstChange) {
        // force set muted if html atribute is setted, for allow autoplay without user interaction
        if (me._el.nativeElement.getAttribute("muted") == "") {
          me._el.nativeElement.muted = true;
        }
        me._el.nativeElement.setAttribute("onerror", "this.onerror=null;this.src='" + CoreVideoService.errorImageURL + "';");
      }
      me.setVideo(src.currentValue);
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._subscription) {
      me._subscription.unsubscribe();
    }
  }
}
